import { Header } from '../../../components/feature/Header';
import { Footer } from '../../../components/feature/Footer';
import { MidRiseApartmentsHero } from './components/MidRiseApartmentsHero';
import { WhatAreMidRiseApartments } from './components/WhatAreMidRiseApartments';
import { WhyWeSpecialize } from './components/WhyWeSpecialize';
import { PropertyTypesWeBuy } from './components/PropertyTypesWeBuy';
import { OurPurchaseProcess } from './components/OurPurchaseProcess';
import { SellerBenefits } from './components/SellerBenefits';
import { CommonChallenges } from './components/CommonChallenges';
import { MarketInsights } from './components/MarketInsights';
import { CaseStudies } from './components/CaseStudies';
import { GetOfferSection } from './components/GetOfferSection';
import { MidRiseApartmentsFAQ } from './components/MidRiseApartmentsFAQ';
import { FinalCTA } from './components/FinalCTA';

export default function MidRiseApartmentsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <MidRiseApartmentsHero />
      <WhatAreMidRiseApartments />
      <WhyWeSpecialize />
      <PropertyTypesWeBuy />
      <OurPurchaseProcess />
      <SellerBenefits />
      <CommonChallenges />
      <MarketInsights />
      <CaseStudies />
      <GetOfferSection />
      <MidRiseApartmentsFAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}